import {
    UPDATE_ENGINEER_REQUEST,
    UPDATE_ENGINEER_SUCCESS,
    UPDATE_ENGINEER_FAILURE,
    ENGINEER_DOCUMENT_UPLOAD_REQUEST,
    ENGINEER_DOCUMENT_UPLOAD_SUCCESS,
    ENGINEER_DOCUMENT_UPLOAD_FAILURE,
    ENGINEER_DOCUMENT_DELETE_REQUEST,
    ENGINEER_DOCUMENT_DELETE_SUCCESS,
    ENGINEER_DOCUMENT_DELETE_FAILURE
} from '../actions';

export const ENGINEER_INITIAL_STATE = {
    isFetching: false,
    isUploading: false,
    isRemoving: false,
    error: null,
    uploadError: null,
    removeError: null,
    documents: []
};

const engineerReducers = {
    [UPDATE_ENGINEER_REQUEST]: (state) => {
        return {...state, isFetching: true, error: null};
    },
    [UPDATE_ENGINEER_SUCCESS]: (state, {res}) => {
        return {...state, ...res.data, isFetching: false, error: null};
    },
    [UPDATE_ENGINEER_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [ENGINEER_DOCUMENT_UPLOAD_REQUEST]: (state) => {
        return {...state, isUploading: true, uploadError: null};
    },
    [ENGINEER_DOCUMENT_UPLOAD_SUCCESS]: (state, {res}) => {
        return {...state, ...res.data, isUploading: false, uploadError: null};
    },
    [ENGINEER_DOCUMENT_UPLOAD_FAILURE]: (state, {error}) => {
        return {...state, isUploading: false, uploadError: error};
    },
    [ENGINEER_DOCUMENT_DELETE_REQUEST]: (state) => {
        return {...state, isRemoving: true, removeError: null};
    },
    [ENGINEER_DOCUMENT_DELETE_SUCCESS]: (state, {docId}) => {
        const documents = [...state.documents].filter(doc => doc.id !== docId);

        return {...state, documents, isRemoving: false, removeError: null}
    },
    [ENGINEER_DOCUMENT_DELETE_FAILURE]: (state, {error}) => {
        return {...state, isRemoving: false, removeError: error};
    }
};

export default function engineers(state = ENGINEER_INITIAL_STATE, action) {
    let reducer = engineerReducers[action.type] || (state => state);
    return reducer(state, action);
}


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/engineer.js